import { call, put, select } from 'redux-saga/effects';
import { cleanupAudioStreamSaga } from 'features/streaming/sagas/cleanupAudioStreamSaga';
import { selectPhoneStream } from 'features/sip/sipSlice';
import { phoneStreamDeleted } from 'features/sip/actions';
import { PhoneStream } from 'features/sip/types';

export function* onPhoneBridgeDisconnectSaga() {
  const currentPhoneStream: PhoneStream = yield select(selectPhoneStream);

  if (currentPhoneStream) {
    yield call(
      cleanupAudioStreamSaga,
      currentPhoneStream.feedId,
      currentPhoneStream.feedId,
      currentPhoneStream.streams[0].mid
    );

    yield put(phoneStreamDeleted(currentPhoneStream.feedId));
  }
}
